export default "__VITE_ASSET__BQmUBgCW__"